import { render, staticRenderFns } from "./ProgramsTrade.vue?vue&type=template&id=67db3816&"
import script from "./ProgramsTrade.vue?vue&type=script&lang=js&"
export * from "./ProgramsTrade.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67db3816')) {
      api.createRecord('67db3816', component.options)
    } else {
      api.reload('67db3816', component.options)
    }
    module.hot.accept("./ProgramsTrade.vue?vue&type=template&id=67db3816&", function () {
      api.rerender('67db3816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/program/ProgramsTrade.vue"
export default component.exports